// Logout actions
export const USER_LOGOUT = '@@toyota/USER_LOGOUT';
export const USER_LOGIN_SUCCESS = '@@toyota/USER_LOGIN_SUCCESS';
export const USER_UPDATE_ACCESS_TOKEN = '@@toyota/USER_UPDATE_ACCESS_TOKEN';
export const SAVING_LOGIN_LOGGER = '@@toyota/SAVING_LOGIN_LOGGER';
export const SAVED_LOGIN_LOGGER = '@@toyota/SAVED_LOGIN_LOGGER';
export const SAVED_LOGIN_LOGGER_FAILED = '@@toyota/SAVED_LOGIN_LOGGER_FAILED';
export const REQUESTING_PARTY_TOKEN = '@@toyota/REQUESTING_PARTY_TOKEN';
export const REQUESTED_PARTY_TOKEN = '@@toyota/REQUESTED_PARTY_TOKEN';
export const REQUESTED_PARTY_TOKEN_FAILED = '@@toyota/FREQUESTED_PARTY_TOKEN_FAILED';
export const FETCHING_LAST_LOGIN = '@@toyota/FETCHING_LAST_LOGIN';
export const FETCHED_LAST_LOGIN = '@@toyota/FETCHED_LAST_LOGIN';
export const FETCHED_LAST_LOGIN_FAILED = '@@toyota/FETCHED_LAST_LOGIN_FAILED';
export const GET_USER_INFO_REQUEST = '@@toyota/GET_USER_INFO_REQUEST';
export const GET_USER_INFO_SUCCESS = '@@toyota/GET_USER_INFO_SUCCESS';
export const GET_USER_INFO_FAILED = '@@toyota/GET_USER_INFO_FAILED';
